/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Signed_OutInputs */

const th_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์ของคุณ`)
};

const en_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your profile`)
};

const ja_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのプロフィール`)
};

const zh_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的个人资料`)
};

const es_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu perfil`)
};

const pt_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu perfil`)
};

const id_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil Anda`)
};

const fr_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre profil`)
};

const tl_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang profile mo`)
};

const vi_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ của bạn`)
};

const ko_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 프로필`)
};

const de_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Profil`)
};

const ru_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш профиль`)
};

const tr_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiliniz`)
};

const it_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo profilo`)
};

const pl_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój profil`)
};

const uk_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш профіль`)
};

const hi_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी प्रोफ़ाइल`)
};

const ar_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملفك الشخصي`)
};

const ms_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil anda`)
};

const bn_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার প্রোফাইল`)
};

const zh_tw2_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的個人資料`)
};

const zh_hk2_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的個人資料`)
};

const ur_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کی پروفائل`)
};

const fa_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمایهٔ شما`)
};

const sw_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasifu wako`)
};

const nl_profile_signed_out = /** @type {(inputs: Profile_Signed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw profiel`)
};

/**
* | output |
* | --- |
* | "Your profile" |
*
* @param {Profile_Signed_OutInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_signed_out = /** @type {((inputs?: Profile_Signed_OutInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Signed_OutInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_signed_out(inputs)
	if (locale === "ja") return ja_profile_signed_out(inputs)
	if (locale === "zh") return zh_profile_signed_out(inputs)
	if (locale === "es") return es_profile_signed_out(inputs)
	if (locale === "pt") return pt_profile_signed_out(inputs)
	if (locale === "id") return id_profile_signed_out(inputs)
	if (locale === "fr") return fr_profile_signed_out(inputs)
	if (locale === "tl") return tl_profile_signed_out(inputs)
	if (locale === "vi") return vi_profile_signed_out(inputs)
	if (locale === "ko") return ko_profile_signed_out(inputs)
	if (locale === "de") return de_profile_signed_out(inputs)
	if (locale === "ru") return ru_profile_signed_out(inputs)
	if (locale === "tr") return tr_profile_signed_out(inputs)
	if (locale === "it") return it_profile_signed_out(inputs)
	if (locale === "pl") return pl_profile_signed_out(inputs)
	if (locale === "uk") return uk_profile_signed_out(inputs)
	if (locale === "hi") return hi_profile_signed_out(inputs)
	if (locale === "ar") return ar_profile_signed_out(inputs)
	if (locale === "ms") return ms_profile_signed_out(inputs)
	if (locale === "bn") return bn_profile_signed_out(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_signed_out(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_signed_out(inputs)
	if (locale === "ur") return ur_profile_signed_out(inputs)
	if (locale === "fa") return fa_profile_signed_out(inputs)
	if (locale === "sw") return sw_profile_signed_out(inputs)
	if (locale === "nl") return nl_profile_signed_out(inputs)
	return en_profile_signed_out(inputs)
});